import { isMoreThan3Days } from '../../../utils/dateTimeHelpers';
import { formatDayMonth } from 'shared/utils/dateHelpers';

export const ZERO_TIME = '00:00:00';

export type CountdownDirection = 'startsIn' | 'endsIn';

export interface CountdownResult {
  label: string;
  value: string;
  direction: CountdownDirection;
  isTicking: boolean;
}

const getPaddedTimeUnit = (unit: number) => String(unit).padStart(2, '0');

export const getTimeDiffFormatted = (from: Date, to: Date) => {
  const diff = Math.max(0, to.getTime() - from.getTime());
  const totalSeconds = Math.floor(diff / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${getPaddedTimeUnit(hours)}:${getPaddedTimeUnit(minutes)}:${getPaddedTimeUnit(seconds)}`;
};

export const createCountdownResult = (
  now: Date,
  targetDate: Date,
  direction: CountdownDirection,
  t: (key: string, fallback: string) => string,
): CountdownResult => {
  const isOver3Days = isMoreThan3Days(now, targetDate);
  const isStarting = direction === 'startsIn';
  const labelKey = isStarting
    ? isOver3Days ? 'campaigns.starts_on' : 'campaigns.starts_in'
    : isOver3Days ? 'campaigns.ends_on' : 'campaigns.ends_in';
  const labelFallback = isStarting
    ? isOver3Days ? 'Starts On' : 'Starts In'
    : isOver3Days ? 'Ends On' : 'Ends In';

  return {
    label: t(labelKey, labelFallback),
    value: isOver3Days ? formatDayMonth(targetDate) : getTimeDiffFormatted(now, targetDate),
    direction,
    isTicking: !isOver3Days,
  };
};
